import React from 'react';

import { DropDownProps } from 'antd/lib/dropdown';
// TODO: this is a temporary workaround for eslint until bsa-ui is fixed

/* eslint-disable import/named */
import { Dropdown as BsaDropdown } from 'bsa-ui';

import { ModalContextContainerConsumer } from '../Modal';

const Dropdown: React.FC<DropDownProps> = ({
  getPopupContainer = null,
  ...rest
}) => (
  <ModalContextContainerConsumer>
    {getModalPopupContainer => (
      <BsaDropdown
        getPopupContainer={
          getPopupContainer
            ? getPopupContainer
            : (getModalPopupContainer as unknown as (
                triggerNode: HTMLElement,
              ) => HTMLElement)
        }
        {...rest}
      />
    )}
  </ModalContextContainerConsumer>
);

export default Dropdown;
